import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useParams } from "react-router-dom";
import routing from "routing";
import { ArticleView } from "src/components/Article/ArticleView";
import { ArticleViewSkeleton } from "src/components/Article/ArticleViewSkeleton";
import { useArticle } from "src/hooks/useArticle";

/** Artykuł z GET /v2/articles/:id (MySQL), ten sam widok co w adminie. */
export function Article() {
	const { t } = useTranslation();
	const { id } = useParams<{ id: string }>();
	const history = useHistory();
	// key jest tylko przy nawigacji w apce; wejście z zewnątrz (nowa karta, link) nie ma czego cofać
	const canGoBack = !!useLocation().key;
	const { isLoading, data: article } = useArticle(Number(id));

	if (isLoading) {
		return <ArticleViewSkeleton />;
	}

	if (!article) {
		return null;
	}

	return (
		<ArticleView
			article={article}
			back={{
				to: routing.paths.knowledgeBase,
				label: t("articles.back", "Baza wiedzy"),
				// jak „wstecz” w przeglądarce: wraca do szukajki z tymi samymi filtrami i stroną
				onClick: canGoBack ? history.goBack : undefined,
			}}
		/>
	);
}
